import FeedbackListView from './FeedbackListView';

export default FeedbackListView;
